import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as r, normalizeClass as l, createElementVNode as a } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const h = {
  name: "DtIconFreshdesk",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], u = /* @__PURE__ */ a("path", {
  d: "M20.976 0A3.002 3.002 0 0 1 24 3.027v9.011C24 18.646 18.645 24 12.037 24h-.068A11.959 11.959 0 0 1 0 12.041C0 5.414 5.346.068 11.963.001h9.013Zm-9.022 5.35a5.486 5.486 0 0 0-5.487 5.492v3.736c.021 1 .827 1.807 1.827 1.828h1.554v-4.293h-2.1v-1.199a4.27 4.27 0 0 1 4.262-4.028 4.263 4.263 0 0 1 4.256 4.028v1.2h-2.13v4.295h1.405v.069a1.713 1.713 0 0 1-1.688 1.687h-1.677c-.137 0-.286.068-.286.204a.301.301 0 0 0 .286.286h1.687a2.195 2.195 0 0 0 2.182-2.181v-.137a1.8 1.8 0 0 0 1.404-1.772v-3.94c-.085-2.959-2.483-5.275-5.495-5.275Z",
  fill: "#25C16F"
}, null, -1), f = /* @__PURE__ */ a("path", {
  d: "M11.955 5.349a5.486 5.486 0 0 0-5.487 5.492v3.736c.021 1 .827 1.807 1.827 1.828h1.554v-4.293h-2.1v-1.199a4.27 4.27 0 0 1 4.262-4.028 4.263 4.263 0 0 1 4.256 4.028v1.2h-2.13v4.295h1.405v.069a1.713 1.713 0 0 1-1.688 1.687h-1.677c-.137 0-.286.068-.286.204a.301.301 0 0 0 .286.286h1.687a2.195 2.195 0 0 0 2.182-2.181v-.137a1.8 1.8 0 0 0 1.404-1.772v-3.94c-.085-2.959-2.483-5.275-5.495-5.275Z",
  fill: "#fff"
}, null, -1), v = [
  u,
  f
], m = ["id"], p = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}, null, -1), g = [
  p
];
function I(e, b, s, q, C, t) {
  return r(), n("svg", {
    "aria-label": s.ariaLabel,
    class: l([t.iconSizeClass, "d-icon d-icon--freshdesk"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Freshdesk",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, v, 8, _),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, g, 8, m)
    ])
  ], 10, c);
}
const D = /* @__PURE__ */ o(h, [["render", I]]);
export {
  D as default
};
//# sourceMappingURL=freshdesk.js.map
